<div #toastOutlet></div>

<div class="flex">
  <div class="flex min-h-0 flex-col w-full lg:p-11 p-6 card">
    <div class="flex justify-between mb-4">
      <p class="lg:text-4xl text-2xl font-bold">
        View Test Set
      </p>
    </div>
    @if (isLoading()) {
    <div class="flex items-center justify-center h-full">
      <span class="loading loading-dots loading-lg"></span>
    </div>
    } @else {
    <div class="flex flex-col lg:flex-row lg:gap-6 gap-1.5">
      <div class="flex flex-col flex-1 gap-1.5">
        <!-- Test Set Name -->
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">
              Test Set Name
            </legend>
          </div>
          <input
            name="testSetName"
            type="text"
            [value]="testSet()?.title"
            class="w-full input placeholder-gray-300 rounded-lg"
            placeholder="Enter Test Set Name"
            disabled />
        </div>

        <!-- Test Set Difficulty -->
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">
              Difficulty of Problems
            </legend>
          </div>
          <app-select
            id="difficulty-selector"
            name="difficulty-selector"
            [items]="selectItems()"
            [(selectedItem)]="selectedDifficulty"
            [disabled]="true"
            />
        </div>
      </div>

      <div class="flex flex-col flex-1">
        <!-- Test Set Description -->
        <div class="flex-col w-full h-full">
          <div class="flex">
            <legend class="fieldset-legend">
              Test Set Description
            </legend>
          </div>
          <textarea
            name="testSetDescription"
            [value]="testSet()?.description"
            class="w-full textarea placeholder-gray-300 rounded-lg min-h-35 lg:min-h-31"
            placeholder="Enter Test Set Description"
            disabled></textarea>
        </div>
      </div>
    </div>

    <div class="lg:pt-12 pt-6">
      <p class="text-xl lg:text-2xl font-semibold text-black mb-3" id="problems-heading">
        Problems
      </p>
    </div>

    <div class="flex flex-col space-y-4">
      @if (selectedProblems().length === 0) {
      <p class="text-gray-500">No problems selected.</p>
      } @else {
        @for(item of selectedProblems(); track item.problemId) {
          <!-- problems item -->
          <div class="flex flex-row justify-between gap-3.5 w-full" id="problem-item">
            <div class="w-full">
              <app-item
                [title]="item.title"
                [description]="item.description"
                [difficulty]="item.difficulty"
                [duration]="item.duration" />
            </div>
          </div>
        }
      }
    </div>

    <div class="mt-5 flex flex-row justify-end gap-3.5">
      <div class="w-fit">
        <app-button
          type="button"
          label="Back"
          routerLink="/test-sets" />
      </div>
    </div>
    }
  </div>
</div>
